<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <div class="search-left">
                    <el-select v-model="query.news_type" placeholder="订单类型" class="handle-input mr10">
                        <el-option v-for="item in planNewsTypeList" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                    </el-select>
                    <el-select v-model="query.company_id" placeholder="执行公司" filterable clearable class="handle-input mr10" @change="change">
                        <el-option v-for="(item, index) in dictionary.getPicker('company')" :key="index" :label="item.title" :value="item.id+''"></el-option>
                    </el-select>
                    <el-select v-model="query.hotel_id" placeholder="举办酒店" class="handle-input mr10" filterable clearable>
                        <el-option v-for="(item, index) in dictionary.getPicker('hotel')" :key="index" :label="item.title" :value="item.id+''"></el-option>
                    </el-select>
                    <el-date-picker class="daterange mr10" v-model="query.date_range" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    <el-button type="primary" class="btn-search ml8" @click="getTableData">搜索</el-button>
                    <el-popover placement="bottom" width="600" trigger="click">
                        <div class="help-container">
                            <div>
                                <el-tag type="danger">花艺单状态</el-tag>
                                <dl class="help-box">
                                    <dt>待分配:</dt>
                                    <dd>策划师未提交需求</dd>
                                </dl>
                            </div>
                            <div>
                                <el-tag type="danger">已派单状态</el-tag>
                                <dl class="help-box">
                                    <dt class="w150">已派单-[待审核]:</dt>
                                    <dd>已派单-[待审核]</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt class="w150">已派单-[审核驳回]:</dt>
                                    <dd>已派单-[审核驳回]</dd>
                                </dl>
                                <dl class="help-box">
                                    <dt class="w150">已派单-[审核通过]:</dt>
                                    <dd>已派单-[审核通过]</dd>
                                </dl>
                            </div>
                        </div>
                        <el-button slot="reference" class="ml8" type="danger">注解</el-button>
                    </el-popover>
                </div>
            </div>
        </div>
        <!-- 搜索E -->
        <!-- 搜索E -->
        <div class="nav-check-status">
            <el-radio-group v-model="query.is_flower_send" @change="changeHandler">
                <el-radio-button label="0">待分配</el-radio-button>
                <el-radio-button label="1">已派单</el-radio-button>
            </el-radio-group>
        </div>
        <div class="table-box">
            <el-table @selection-change="handleSelectionChange" ref="multipleTable" :data="tableData" border :height="tableHeight" :max-height="tableHeight" v-loading="loading" @sort-change="sortChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column prop="planner[0].realname" label="策划师"></el-table-column>
                <el-table-column prop="wedding_company" label="婚庆执行公司"></el-table-column>
                <el-table-column prop="bridegroom" label="客户姓名"></el-table-column>
                <el-table-column prop="hotel" label="酒店" show-overflow-tooltip></el-table-column>
                <el-table-column prop="hall" label="厅" show-overflow-tooltip></el-table-column>
                <el-table-column prop="event_date" label="举办日期" align="center" sortable="custom"></el-table-column>
                <el-table-column prop="project" label="花艺单" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="showDrawerPass(_self, 'planDetail', 'showDrawer', [scope.row.id])">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 底部操作栏 -->
        <div class="footer-box">
            <div class="download" v-if="query.is_flower_send==0">
                <el-button type="primary" class="btn-search ml8" @click="summaryDispatch">汇总分派</el-button>
            </div>
            <div class="pagination">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.page" :page-sizes="[15, 20, 50, 100]" :page-size="pagination.limit" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
            </div>
        </div>

        <plan-detail ref="planDetail" :parent="_self"></plan-detail>
        <summary-detail ref="summaryDetail" :parent="_self"></summary-detail>
    </div>
</template>

<script>
import {
    showDrawerPass,
    getItemCheckTitle
} from '@/utils/common.js';
import dictionary from '@/utils/dictionary';
import planDetail from './detail.vue';
import summaryDetail from './summaryDetail/detail.vue';
const query = {
    news_type: "",
    company_id: "",
    date_range: [],
    hotel_id: "",
    is_flower_send: "0"
};

export default {
    components: {
        planDetail,
        summaryDetail
    },
    data() {
        let tableHeight = window.innerHeight - 282;
        let windowheight = window.innerHeight;
        return {
            plannerList: [],
            tableData: [],
            query: Object.assign({}, query), // 搜索条件
            tableHeight: tableHeight,
            windowheight: windowheight,
            pagination: {
                page: 1,
                limit: 15,
                totals: 0
            },
            loading: false,
            sort: {},
            router: '',
            // 汇总分派
            summaryForm: {
                order_id: [],
            },

        };
    },
    computed: {
        planNewsTypeList() {
            let planList = [{
                id: "1",
                title: "婚庆信息"
            },
            {
                id: "7",
                title: "宝宝宴"
            },
            {
                id: "8",
                title: "会务"
            },
            {
                id: "11",
                title: "婚博会"
            },
            {
                id: "12",
                title: "婚礼秀"
            }
            ];

            return planList;
        }
    },
    watch: {
        $route: function (to, from) { }
    },
    beforeCreate() {
        this.showDrawerPass = showDrawerPass;
        this.getItemCheckTitle = getItemCheckTitle;
        this.dictionary = dictionary;

    },
    created() {
        let _this = this;
        _this.getTableData();
    },
    methods: {
        changeHandler(value) {
            this.query.is_flower_send = value;
            this.pagination.page = 1;
            this.getTableData();
        },
        change(e) {
            this.getTableData();
        },
        getTableData() {
            let _this = this;
            _this.loading = true;
            _this.router = _this.$route.path;
            let url = '/api/wedding.flower/index';
            let query = this.query;
            query['pagination'] = _this.pagination;
            query['sort'] = _this.sort;
            this.$post(url, query).then((res) => {
                _this.loading = false;
                if (res.code == '200') {
                    _this.tableData = res.data.list;
                    _this.pagination = res.data.pagination;

                } else {
                    this.$message(res.msg);
                }
            });
        },
        // 主表选中事件
        handleSelectionChange(e) {
            let ids = [];
            e.forEach((row, key) => {
                ids.push(row.id);
            });
            this.summaryForm.order_id = ids;
        },
        summaryDispatch() {
            let _this = this;
            if (_this.summaryForm.order_id.length == 0) {
                _this.$message({
                    type: 'danger',
                    message: "请添加订单"
                });
                return false
            }
            if (_this.query.company_id == "") {
                this.$message.error('请选择婚庆承办公司');
                return false
            }
            if (_this.query.date_range == "") {
                this.$message.error('请选择婚期');
                return false
            }

            if (_this.$refs['summaryDetail']) {
                _this.$refs['summaryDetail'].showDrawer(_this.summaryForm, _this.query);
            } else {
                _this.$nextTick(function () {
                    _this.$refs['summaryDetail'].showDrawer(_this.summaryForm, _this.query);
                })
            }
        },
        // 排序
        sortChange(e) {
            if (e.order) {
                let sort = {};
                sort.field = e.prop;
                sort.order = e.order == 'descending' ? 'desc' : 'asc';
                this.sort = sort;
            } else {
                this.sort = {};
            }
            this.getTableData();
        },
        // 分页
        handleSizeChange(val) {
            this.pagination.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getTableData();
        },
        getStatus(status) {
            let title = '';
            switch (status) {
                case 0:
                    title = '待分配';
                    break;
                case 1:
                    title = '已派单';
                    break;
                case 2:
                    title = '分派中';
                    break;
                case 3:
                    title = '已完成';
                    break;
                case 4:
                    title = '已作废';
                    break;
                default:
                    title = '';
            }

            return title;
        },
        getPlannerList() {
            let _this = this;
            let url = '/api/ucenter.user/roleUserList';
            let params = {
                role_id: [32, 35]
            };
            _this.$post(url, params).then((res) => {
                _this.plannerList = res.data.list;
            });
        }
    }
};
</script>

<style lang="less">
@import url('@/assets/css/common.less');
</style>
